(function () {
  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('a[href*="#"]');
      if (!link || !link.hash) return;

      // Only intercept when the link points to an anchor on the page we're already on.
      // A hash link to a different page should navigate normally.
      if (link.pathname !== window.location.pathname) return;

      const drawer = link.closest('header-drawer');
      if (!drawer || typeof drawer.close !== 'function' || !drawer.isOpen) return;

      const targetId = link.hash.slice(1);
      if (!targetId) return;

      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      drawer.close();

      setTimeout(function () {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', link.hash);
      }, 350);
    },
    true
  );
})();
